import config from '../config'
import { authorizedFetch } from '../utils/auth.js'
import { checkStatus } from '../utils/fetch'
import CircularProgress from 'material-ui/CircularProgress';

export const LOGOUT = 'LOGOUT'
export const REQUEST_USERS = 'REQUEST_USERS'
export const RECEIVE_USERS = 'RECEIVE_USERS'

export const UPDATE_STATUS = 'UPDATE_STATUS'
export const UPDATE_STATUS_SUCCESS = 'UPDATE_STATUS_SUCCESS'

export const UPDATE_USERNAME = 'UPDATE_USERNAME'
export const UPDATE_USERNAME_SUCCESS = 'UPDATE_USERNAME_SUCCESS'

export const UPDATE_ROLE = 'UPDATE_ROLE'
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS'

export const UPDATE_BUILDINGS = 'UPDATE_BUILDINGS'
export const UPDATE_BUILDINGS_SUCCESS = 'UPDATE_BUILDINGS_SUCCESS'

export const UPDATE_COMPANIES = 'UPDATE_COMPANIES'
export const UPDATE_COMPANIES_SUCCESS = 'UPDATE_COMPANIES_SUCCESS'

export const FETCH_LOGIN_TOKEN_SUCCESS = 'FETCH_LOGIN_TOKEN_SUCCESS'

export const SHOW_ACTIVATE_DIALOG = 'SHOW_ACTIVATE_DIALOG'
export const HIDE_ACTIVATE_DIALOG = 'HIDE_ACTIVATE_DIALOG'

export const SELECT_ACTIVE_COMPANY = 'SELECT_ACTIVE_COMPANY'
export const SELECT_ACTIVE_BUILDING = 'SELECT_ACTIVE_BUILDING'

export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS'
export const UPDATE_FILTER = 'UPDATE_FILTER'

export const DELETE_USER_SUCCEDED = 'DELETE_USER_SUCCEDED'
export const SHOW_ADD_USERNAME_FORM = 'SHOW_ADD_USERNAME_FORM'
export const SHOW_USERNAME_DIALOG = 'SHOW_USERNAME_DIALOG'

export const CHECKED_IN = 'CHECKED_IN'
export const CHECKED_OUT = 'CHECKED_OUT'
export const REGISTERED = 'REGISTERED'
export const UNREGISTERED = 'UNREGISTERED'
export const CHANGE_PAGE = 'CHANGE_PAGE_USERS'
export const CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING'
export const CURRENT_USERNAME_CHANGED = 'CURRENT_USERNAME_CHANGED'
export const SHOW_INACTIVE_USERS = 'SHOW_INACTIVE_USERS'

export const RESENT_EMAIL = 'RESENT_EMAIL'
export const CLOSE_RESENT_EMAIL = 'CLOSE_RESENT_EMAIL'
export const CLOSE_USERNAME_DIALOG = 'CLOSE_USERNAME_DIALOG'
export const CURRENT_EMAIL_CHANGED = 'CURRENT_EMAIL_CHANGED'

export const SHOW_EMAIL_DIALOG = 'SHOW_EMAIL_DIALOG'
export const UPDATE_EMAIL_SUCCESS = 'UPDATE_EMAIL_SUCCESS'

export const SHOW_SPINNER = 'SHOW_SPINNER'

export const RESENT_EMAIL_FAILED = 'RESENT_EMAIL_FAILED'
export const SHOW_DEVICES_INFORMATION = 'SHOW_DEVICES_INFORMATION'
export const CLOSE_DEVICES_INFORMATION = 'CLOSE_DEVICES_INFORMATION'

export const resendVerificationEmail = (user, newEmail) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/resendVerificationEmail/' + user._id,
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ email: newEmail, oldEmail: user.email })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(resentEmail(user, newEmail)))
    .catch(function (error) {
      dispatch(resentEmailFailed())
    });
}

export const resentEmail = (user, email) => ({
  type: RESENT_EMAIL,
  user: user,
  email: email
})

export const resentEmailFailed = (error) => ({
  type: RESENT_EMAIL_FAILED,
  error: error
})

export const closeResentEmail = () => ({
  type: CLOSE_RESENT_EMAIL,
})

export const register = (user, session, id) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/register',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user_id: user._id, session_id: session._id, author: id })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(registered(response)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const registered = (session) => ({
  type: REGISTERED,
  session: session
})

export const unregister = (user, session, id) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/unregister',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user_id: user._id, session_id: session._id, author: id })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(unregistered(response)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const unregistered = (session) => ({
  type: UNREGISTERED,
  session: session
})

export const checkIn = (user, session, id) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/checkin',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user_id: user._id, session_id: session._id, author: id })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(checkedIn(response)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const checkedIn = (session) => ({
  type: CHECKED_IN,
  session: session
})

export const checkOut = (user, session, id) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/checkout',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user_id: user._id, session_id: session._id, author: id })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => dispatch(checkedOut(response)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const checkedOut = (session) => ({
  type: CHECKED_OUT,
  session: session
})

export const updateFilter = (filter, value) => ({
  type: UPDATE_FILTER,
  filter: filter,
  value: value
})

export const logOut = () => ({
  type: LOGOUT
})

export const closeActivateDialog = () => ({
  type: HIDE_ACTIVATE_DIALOG,
})

export const showActivateDialog = (user) => ({
  type: SHOW_ACTIVATE_DIALOG,
  user: user
})

export const fetchLoginToken = (accessToken, googleId, email, name) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'auth/google/auth',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ access_token: accessToken, google_id: googleId, email: email, name: name })
    })
    .then(response => response.json())
    .then(response => dispatch(fetchLoginTokenSuccess(response.token, response.email, response.name, response.id, response.role, response.error)))

}

export const fetchLoginTokenSuccess = (token, email, name, id, role, error) => ({
  type: FETCH_LOGIN_TOKEN_SUCCESS,
  token: token,
  email: email,
  name: name,
  id: id,
  role: role,
  error: error
})

export const updateRole = (id, role) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateRole',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, role: role })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateRoleSuccess(id, role)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateRoleSuccess = (id, role) => ({
  type: UPDATE_ROLE_SUCCESS,
  id: id,
  role: role
})

export const updateBuildings = (id, buildings) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateBuildings',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, buildings: buildings })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateBuildingsSuccess(id, buildings)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateBuildingsSuccess = (id, buildings) => ({
  type: UPDATE_BUILDINGS_SUCCESS,
  id: id,
  buildings: buildings
})

export const updateCompanies = (id, companies) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateCompanies',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, companies: companies })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateCompaniesSuccess(id, companies)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateCompaniesSuccess = (id, companies) => ({
  type: UPDATE_COMPANIES_SUCCESS,
  id: id,
  companies: companies
})

export const updateStatus = (id, status) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateStatus',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, status: status })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateStatusSuccess(id, status)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateStatusSuccess = (id, status) => ({
  type: UPDATE_STATUS_SUCCESS,
  id: id,
  status: status
})

export const updateUsername = (id, fullName) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateUsername',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, fullName: fullName })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateUsernameSuccess(id, fullName)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateUsernameSuccess = (id, fullName) => ({
  type: UPDATE_USERNAME_SUCCESS,
  id: id,
  fullName: fullName
})

export const updateEmail = (id, email) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/updateEmail',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ id: id, email: email })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(updateEmailSuccess(id, email)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const updateEmailSuccess = (id, email) => ({
  type: UPDATE_EMAIL_SUCCESS,
  id: id,
  email: email
})

export const activateUser = (userId, companyId, buildingId) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/activate',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user_id: userId, company_id: companyId, building_id: buildingId })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(activateUserSuccess(json)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const activateUserSuccess = (selectedUser) => ({
  type: ACTIVATE_USER_SUCCESS,
  user: selectedUser
})

export const requestUsers = () => ({
  type: REQUEST_USERS
})

export const receiveUsers = (json) => ({
  type: RECEIVE_USERS,
  json: json.data
})

export const fetchUsers = (filters, skip, take) => dispatch => {
    var headers = new Headers()
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Accept', 'application/json');

    authorizedFetch(config.api_url + 'users/list',
      {
        headers: headers,
        mode: 'cors',
        cache: 'default',
        method: "POST",
        body: JSON.stringify({ filters, skip, take })
      })
      .then(checkStatus)
      .then(response => response.json())
      .then(json => dispatch(receiveUsers({ data: json })))
      .catch(function (error) {
        dispatch(logOut())
      });
}

export const selectActivateCompany = (companyId) => ({
  type: SELECT_ACTIVE_COMPANY,
  selectedCompanyId: companyId
})

export const selectActivateBuilding = (buildingId) => ({
  type: SELECT_ACTIVE_BUILDING,
  selectedBuildingId: buildingId
})

export const deleteUser = (user) => dispatch => {

  var headers = new Headers()
  headers.append('Content-Type', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('Accept', 'application/json');

  authorizedFetch(config.api_url + 'users/delete',
    {
      headers: headers,
      mode: 'cors',
      cache: 'default',
      method: "POST",
      body: JSON.stringify({ user: user })
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(deleteUserSucceded(json)))
    .catch(function (error) {
      dispatch(logOut())
    });
}

export const deleteUserSucceded = (user) => ({
  type: DELETE_USER_SUCCEDED,
  user: user
})

export const changePage = (pageNumber) => ({
  type: CHANGE_PAGE,
  pageNumber: pageNumber
})

export const changeSearchString = (searchString) => ({
  type: CHANGE_SEARCH_STRING,
  searchString
})

export const showUpdateUsernameForm = (fullName) => ({
  type: SHOW_ADD_USERNAME_FORM,
  fullName
})

export const showUsernameDialog = (selectedUser) => ({
  type: SHOW_USERNAME_DIALOG,
  selectedUser
})

export const showEmailDialog = (selectedUser) => ({
  type: SHOW_EMAIL_DIALOG,
  selectedUser
})

export const currentUsernameChanged = (typedUsername) => ({
  type: CURRENT_USERNAME_CHANGED,
  typedUsername
})

export const currentEmailChanged = (typedEmail) => ({
  type: CURRENT_EMAIL_CHANGED,
  typedEmail
})

export const closeUsernameDialog = () => ({
  type: CLOSE_USERNAME_DIALOG
})

export const closeDevicesInformation = () => ({
  type: CLOSE_DEVICES_INFORMATION
})

export const showInactiveUsers = (showInactiveUsers) => ({
  type: SHOW_INACTIVE_USERS,
  showInactiveUsers
})

export const showSpinner = () =>  ({
  type: SHOW_SPINNER
})
export const showDevicesInformation = (selectedUser, deviceType) => ({
  type: SHOW_DEVICES_INFORMATION,
  selectedUser,
  deviceType
})



// WEBPACK FOOTER //
// ./src/actions/users.js